import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["desktop", "desktopButton", "mobileButton", "mobilePanel"]

  initialize() {
    this.closeFromOutside = this.closeFromOutside.bind(this)
    this.closeFromEscape = this.closeFromEscape.bind(this)
  }

  connect() {
    window.addEventListener("click", this.closeFromOutside)
    window.addEventListener("keydown", this.closeFromEscape)
    this.updateExpandedState()
  }

  disconnect() {
    window.removeEventListener("click", this.closeFromOutside)
    window.removeEventListener("keydown", this.closeFromEscape)
  }

  toggleDesktop(event) {
    if (event.target.closest(".dropdown-menu")) return

    event.preventDefault()
    const open = !this.desktopTarget.classList.contains("open")

    this.close()
    this.desktopTarget.classList.toggle("open", open)
    this.desktopButtonTarget.classList.toggle("open", open)
    this.updateExpandedState()
  }

  toggleMobile(event) {
    event.preventDefault()
    const open = !this.mobilePanelTarget.classList.contains("open")

    this.close()
    this.mobilePanelTarget.classList.toggle("open", open)
    this.mobileButtonTarget.classList.toggle("open", open)
    this.updateExpandedState()
  }

  close() {
    this.desktopTarget.classList.remove("open")
    this.desktopButtonTarget.classList.remove("open")
    this.mobilePanelTarget.classList.remove("open")
    this.mobileButtonTarget.classList.remove("open")
    this.updateExpandedState()
  }

  closeFromOverlay(event) {
    if (event.target === event.currentTarget) {
      this.close()
    }
  }

  closeFromOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  closeFromEscape(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }

  updateExpandedState() {
    this.desktopButtonTarget.setAttribute("aria-expanded", this.desktopTarget.classList.contains("open").toString())
    this.mobileButtonTarget.setAttribute("aria-expanded", this.mobilePanelTarget.classList.contains("open").toString())
  }
}
